import controller from './categories-accordion.controller';
import templateBase from './templates/categories-accordion-base.view.html';
import templateT1 from './templates/categories-accordion-t1.html';
import templateT2 from './templates/categories-accordion-t2.html';
import templateT10 from './templates/categories-accordion-t10.html';
import templateT11 from './templates/categories-accordion-t11.html';
import templateT13 from './templates/categories-accordion-t13.html';
import templateT15 from './templates/categories-accordion-t15.html';
import templateAD from './templates/categories-accordion-adaptative.html';

let CategoriesAccordionComponent = {
  template: changeTemplate,
  controller,
  bindings: {
    items: '<',
    hCtrl: '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  if (__env.adaptative) {
    return templateAD;
  } else {
    let response = SessionService.get('components');
    if (response.CATEGORIES_SLIDER_FILTER.component == 'template_t1') { return templateT1; }
    else if (response.CATEGORIES_SLIDER_FILTER.component == 'template_t2') { return templateT2; }
    else if (response.CATEGORIES_SLIDER_FILTER.component == 'template_t10') { return templateT10; }
    else if (response.CATEGORIES_SLIDER_FILTER.component == 'template_t11') { return templateT11; }
    else if (response.CATEGORIES_SLIDER_FILTER.component == 'template_t13') { return templateT13; }
    else if (response.CATEGORIES_SLIDER_FILTER.component == 'template_t15') { return templateT15; }
    else {
      return templateBase;
    }
  }

}

export default CategoriesAccordionComponent;


// WEBPACK FOOTER //
// ./www/components/catalog/categories-filter/categories-accordion/categories-accordion.component.js